import { Select, Space, Spin, Typography } from 'antd';
import { FormSelect, FormWrapper } from 'components/form';
import { useTranslation } from 'react-i18next';
import { useSearchHospital } from 'all-in-one-shared-api';
import { useKeycloakReady } from '../../../hooks/useKeycloakReady';
import { useEffect } from 'react';
import { ENGLISH_SYMBOL } from 'i18n';

export const HospitalSelect = () => {
  const { t, i18n } = useTranslation();

  const { token } = useKeycloakReady();
  const keyClockToken = token ?? '';

  const { shouldFetch: shouldFetchSearchHospital, data: hospitals } = useSearchHospital(
    { name: 'searchHospital' },
    keyClockToken,
    undefined,
    undefined,
    undefined,
    '',
    '',
    [],
    {
      shouldRetryOnError: true,
    },
  );

  useEffect(() => {
    shouldFetchSearchHospital(true);
  }, [shouldFetchSearchHospital]);

  const handleOnDoctorSearch = (value: string) => {
    if (!value) return hospitals;
    const foundHospitals = hospitals?.find((hospital) => hospital.name.toLowerCase().indexOf(value.toLowerCase()));
    return foundHospitals ? foundHospitals : hospitals;
  };

  return (
    <FormWrapper name="hospital" label={t('preAuthRequest.requestInformation.hospital.label')}>
      <FormSelect
        name="hospital"
        allowClear
        showSearch
        placeholder={t('preAuthRequest.requestInformation.hospital.placeholder')}
        notFoundContent={hospitals ? <Spin size="small" /> : null}
        onSearch={handleOnDoctorSearch}
      >
        {hospitals?.map((hospital) => (
          <Select.Option key={hospital.name} value={hospital.name} label={hospital.name}>
            <Space direction="vertical" size="small">
              <Typography.Text>{i18n.language === ENGLISH_SYMBOL ? hospital.name : hospital.name_zh}</Typography.Text>
            </Space>
          </Select.Option>
        ))}
      </FormSelect>
    </FormWrapper>
  );
};
